<script setup lang="ts">
import ElementalItem from '../shared/ElementalItem/index.vue'
import AccordeonMainListsTrigger from '../shared/AccordeonMainListsTrigger.vue'
import Accordeon, { type AccordeonEmits } from '@/components/Accordion/index.vue'
import { useRecentElementalQuery } from '~~/src/composables/query/recentElemental/recentElementalQuery'
import { useElementalListsStore } from '~~/src/stores/useElementalListsStore'

const emits = defineEmits<AccordeonEmits>()
const { data, isLoading } = useRecentElementalQuery()
const { state, toggleRecentAccordion } = useElementalListsStore()

const user = useUser()

const elementalsFiltered = computed(() => {
  const query = state.query?.trim().toLowerCase()
  const items = data.value

  if (!items || !query)
    return items

  return items.filter(({ title, id }) => {
    const idStr = id.toString().toLowerCase()
    return title.toLowerCase().includes(query) || idStr.includes(query)
  })
})

const handleClose = () => {
  toggleRecentAccordion(false)
}

const handlerOpen = () => {
  toggleRecentAccordion(true)
}
const accordionRef = ref()

const handleToggle = (isOpen?: boolean) => {
  emits('onToggle', isOpen)
}
</script>

<template>
  <div v-if="user">
    <Accordeon
      ref="accordionRef"
      class="border-b-1 border-b-soft-gray px-2 pb-2"
      :is-open="state.recentAccordionOpen"
      :ignore-events="state.query !== ''"
      @on-close="handleClose"
      @on-open="handlerOpen"
      @on-toggle="handleToggle($event)"
    >
      <template #header>
        <AccordeonMainListsTrigger
          :elementals-type="0"
          title="Recent"
          :is-loading="isLoading"
        >
          <template #icon>
            <span class="text-dark-gray h-3" i-mdi:clock-outline />
          </template>
        </AccordeonMainListsTrigger>
      </template>
      <template #content>
        <div v-if="elementalsFiltered">
          <template
            v-for="list in elementalsFiltered"
            :key="list.id"
          >
            <ElementalItem
              :elemental="{
                ...list,
                id: list.isList ? list.id_list.toString() : list.id,
              }"
            />
          </template>
        </div>
      </template>
    </Accordeon>
  </div>
</template>
